module.exports = __webpack_public_path__ + "h5/img/hetong.ece3a706.png";